export interface IAutocompleteResults {
    hits: IHit[];
    activeHit: number;
    isActive: boolean;
}

export const DefaultAutoCompleteResults: IAutocompleteResults = Object.freeze({
    hits: [],
    activeHit: -1,
    isActive: false,
})

export interface IHit {
    Query: string;
    Qype: string;
}

const AutocompleteBaseUrl = '/api/autocomplete/fetch/'
const AutocompleteSize = 5;

export const fetchAutoCompleteResults = (searchTerm: string) => {
    return window.fetch(`${AutocompleteBaseUrl}${searchTerm}/${AutocompleteSize}`, { method: 'get', headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }) })
        .then(response => response.json())
        .then(response => {
            return response.hits;
        })
        .catch(() => {
            return null;
        });
}

//function removeAutoCompleteDuplicates(data: IAutocompleteResults) {
//    var resultItems = [];
//    var resultDups = [];

//    for (var i = 0; i < data.hits.length; i++) {
//        if (resultDups.indexOf(data.hits[i].query.trim()) === -1) {
//            resultItems.push({ query: data.hits[i].query.trim() } as IHit);
//            resultDups.push(data.hits[i].query.trim());
//        }
//    }

//    data.hits = resultItems
//    return data;
//}